// import { FieldType } from "../components/Formulario";
import api from "./api";

const controller = "permissoes";

export const getAllPermissoes = () => api.get<any>(`api/${controller}`);
